<template>
    <div class="page container" data-page="workshops">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/workshops">Workshops</router-link>
        </div>
        
        <h1 class="title t-align-center">All Workshops</h1>

        <nav class="filters">
            <span class="link active">Upcoming Workshops</span>
        </nav>

        <Workshops :key="`latest_workshops_${workshopsKey}`" :grid="grid" :type="'latest'"></Workshops>
        
        <nav class="filters">
            <span class="link active">Past Workshops</span>
        </nav>

        <Workshops :key="`past_workshops_${workshopsKey}`" :grid="grid" :type="'past'"></Workshops>

        <Membership></Membership>
    </div>
</template>

<script>
    import Workshops from '../components/Workshops.vue'
    import Membership from '../components/Membership.vue'

    export default {
        data(){
            return{
                grid: '4',
                type: 'latest',
                workshopsKey: 0
            }
        },

        components: {
            Workshops,
            Membership
        },

        methods: {
            toggleWorkshopType(type){
                this.type = type
                this.workshopsKey += 1
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Workshops.vue